import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Button, Statistic, Card, Descriptions, Tag, Divider, message, Space, Tooltip} from 'antd';
import copy from 'copy-to-clipboard';
import {useAsync} from 'react-use';

import {PUBLIC_URL} from '@/env';
import {CopyOutlined} from '@/icons';
import {getFileUrl} from '@/page/component/attachUtils';
import {getEntrypointUrlRoot, getNewsStat} from './extra-news';
import {getCommentCount} from '@/api/comment';
import ExtraNewsCommentDrawer from './ExtraNewsCommentDrawer';
import ExtraNewsSendDrawer from './ExtraNewsSendDrawer';

import styles from './ExtraNewsItemView.module.less';

ExtraNewsItemView.propTypes = {
    newsItem: PropTypes.object,
};

function ExtraNewsItemView({newsItem}) {
    const ExtraNewsCommentDrawerRef = useRef();
    const ExtraNewsSendDrawerRef = useRef();

    const {value: urlRoot} = useAsync(() => {
        return getEntrypointUrlRoot().then(({data}) => data);
    }, []);

    const {value: commentCount} = useAsync(() => {
        if (!newsItem) {
            return Promise.resolve(0);
        }
        return getCommentCount(newsItem.id).then(({data}) => data);
    }, [newsItem]);
    console.log('commentCount', commentCount);

    const {value: stat} = useAsync(() => {
        if (!newsItem) {
            return Promise.resolve({accessCount: 0, praiseCount: 0});
        }
        return getNewsStat(newsItem.id).then(({data}) => data);
    }, [newsItem]);
    console.log('stat', stat);

    if (!newsItem) {
        return null;
    }
    const url = `${window.location.origin}${PUBLIC_URL}/extranews/${newsItem.id}`;

    function onCopyClick() {
        copy(url);
        message.info('链接拷贝成功');
    }

    function onCommentPreviewClick() {
        ExtraNewsCommentDrawerRef.current.show(newsItem.id);
    }

    function onSendClick() {
        ExtraNewsSendDrawerRef.current.show();
    }

    const extra = (
        <Button type="link" onClick={onSendClick}>
            发送单图文消息
        </Button>
    );
    const labelStyle = {width: 120, fontWeight: 'bold'};

    const thumbUrl = getFileUrl(newsItem.thumbAttachId, newsItem.thumbAttachExt);

    const entrypointUrl = `${urlRoot}/${newsItem.entrypointId}/${newsItem.entrypointPath}`;

    const statExtra =
        commentCount > 0 ? (
            <Button type="link" onClick={onCommentPreviewClick}>
                查看评论
            </Button>
        ) : null;
    // console.log(entrypointUrl);
    return (
        <Space direction="vertical" size="large" style={{display: 'flex'}}>
            <Card title="图文链接" size="small" extra={extra}>
                <div className={styles.url}>
                    {url}
                    <Tooltip title="拷贝链接" placement="left">
                        <Button
                            style={{marginLeft: 10}}
                            icon={<CopyOutlined />}
                            type="text"
                            size="small"
                            onClick={onCopyClick}
                        />
                    </Tooltip>
                </div>

                <ExtraNewsSendDrawer
                    ref={ExtraNewsSendDrawerRef}
                    tmpIds={[newsItem.id]}
                    newsById={{[newsItem.id]: newsItem}}
                    currentTmpId={newsItem.id}
                    multi={false}
                    newsId={newsItem.id}
                    appId={newsItem.appId}
                />
            </Card>
            <Card title="图文统计" size="small" extra={statExtra}>
                <Space size="large">
                    <Statistic title="访问量" value={stat?.accessCount ?? 0} />
                    <Statistic title="点赞数" value={stat?.praiseCount ?? 0} />
                    <Statistic title="评论数" value={commentCount} />
                </Space>
                <ExtraNewsCommentDrawer ref={ExtraNewsCommentDrawerRef} />
            </Card>

            <Card title={newsItem.title} size="small">
                <img src={thumbUrl} className={styles.thumb} alt="封面" />
                <Divider />
                <Button type="link" href={entrypointUrl} target="_blank">
                    iframe 图文预览
                </Button>
                <Divider />
                <Descriptions column={1}>
                    <Descriptions.Item label="所属应用" labelStyle={labelStyle}>
                        <Tag color="blue">{newsItem.appName}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="摘要" labelStyle={labelStyle}>
                        {newsItem.description}
                    </Descriptions.Item>
                    <Descriptions.Item label="留言控制" labelStyle={labelStyle}>
                        {newsItem.newsCommentType === 0
                            ? '开启留言，仅企业微信成员可留言'
                            : '关闭留言'}
                    </Descriptions.Item>
                    <Descriptions.Item label="安全控制" labelStyle={labelStyle}>
                        {newsItem.newsAccessType === 0
                            ? '无限制，所有人可访问'
                            : '仅企业微信成员可访问'}
                    </Descriptions.Item>
                    {newsItem.newsContentForbidCopy && (
                        <Descriptions.Item
                            label=" "
                            labelStyle={{...labelStyle, visibility: 'hidden'}}
                        >
                            正文禁止复制
                        </Descriptions.Item>
                    )}
                    {newsItem.newsContentMask && (
                        <Descriptions.Item
                            label=" "
                            labelStyle={{...labelStyle, visibility: 'hidden'}}
                        >
                            正文加水印
                        </Descriptions.Item>
                    )}
                    {newsItem.newsShowReadNum && (
                        <Descriptions.Item
                            label=" "
                            labelStyle={{...labelStyle, visibility: 'hidden'}}
                        >
                            展示阅读数
                        </Descriptions.Item>
                    )}
                    {newsItem.newsShowPraiseNum && (
                        <Descriptions.Item
                            label=" "
                            labelStyle={{...labelStyle, visibility: 'hidden'}}
                        >
                            展示点赞数
                        </Descriptions.Item>
                    )}
                </Descriptions>
            </Card>
        </Space>
    );
}

export default ExtraNewsItemView;
